"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useThrottleDebounce = void 0;
var lodash_1 = require("lodash");
var react_1 = require("react");
var useThrottleDebounce = function (tTime, dTime) {
    if (tTime === void 0) { tTime = 2000; }
    if (dTime === void 0) { dTime = 1000; }
    var tRef = (0, react_1.useRef)(null);
    var tFunc = (0, react_1.useRef)(null);
    var _a = (0, react_1.useState)(null), tDHook = _a[0], setTDHook = _a[1];
    (0, react_1.useEffect)(function () {
        setTDHook(throttleDebounceCreator);
        return function () {
            setTDHook(null);
        };
    }, []);
    var throttleDebounceCreator = function () {
        return function (func) {
            tFunc.current = func;
            debounceThrottle();
        };
    };
    var debounceThrottle = (0, lodash_1.debounce)(function () {
        var _a;
        if ((_a = tRef.current) === null || _a === void 0 ? void 0 : _a.cancel) {
            tRef.current.cancel();
        }
        tRef.current = (0, lodash_1.throttle)(tFunc.current, tTime)();
    }, dTime);
    return tDHook;
};
exports.useThrottleDebounce = useThrottleDebounce;
